export default {
  primary: 'white',
  mainStar: '#f199a7',
  auxStar: '#7887e7',
  green: '#46dcb3',
  orange: '#ffc271',

  background: {
    default: 'white', //'#f3f3f5',
    transparent: 'rgba(243, 243, 245, 0.5)',
    backdrop: 'rgba(0, 0, 0, 0.3)',
  },
  self: '#f199a7',
  life: '#ffc271',
  text: {
    default: '#333',
    inverse: 'white',
    primary: '#6c6a55',
    comment: '#9db4b7',
  },

  border: '#e0d5d6',
  divider: '#e9e59a',
  accent: '#99b2a4',
}
